import React, { useMemo, useState } from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import PatientFilesEmptyState from './PatientFilesEmptyState';
import FilePreviewDrawer from '../session/FilePreviewDrawer';

export default function PatientFileList({ files, pagination, onPageChange, activeFile }) {
  const { t } = useTranslation();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
    setSelectedFile(null);
  };

  const handleOpenFullFile = () => {
    if (selectedFile) {
      window.open(selectedFile.getUrl(), '_blank', 'noopener,noreferrer');
    }
  };

  const columns = useMemo(() => [
    {
      title: '',
      dataIndex: 'file_name',
      key: 'file_name',
      width: 250,
      render: (text, record) => {
        return (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span 
              onClick={() => handleFileClick(record)}
              style={{ 
                color: 'var(--main-color)', 
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
            >
              {record.getFileName()}
            </span>
          </span>
        );
      },
    },
    {
      title: '',
      dataIndex: 'doc_type',
      key: 'doc_type',
      responsive: ['lg'],
      width: 150,
      render: (text, record) => (
        <span style={{ color: record.hasProblem() ? 'grey' : 'inherit' }}>
          {record.getDocType()}
        </span>
      ),
    },
    {
      title: '',
      dataIndex: 'problem',
      key: 'problem',
      responsive: ['lg'],
      width: 150,
      render: (text, record) => (
        record.hasProblem() ? (
          <span style={{ color: '#666' }}>
            {t('session_files.errors.invalid_file', { problem: record.getProblem() })}
          </span>
        ) : null
      ),
    },
    {
      title: '',
      dataIndex: 'relevant_date',
      key: 'relevant_date',
      responsive: ['md'],
      width: 100,
      render: (text, record) => (
        <span style={{ color: record.hasProblem() ? 'grey' : 'inherit' }}>
          {record.getRelevantDate()}
        </span>
      ),
    },
  ], [t, pagination.current]);

  if (files.length === 0) return <PatientFilesEmptyState />;

  return (
    <div style={{ position: 'relative' }}>
      <Table
        showHeader={false}
        columns={columns}
        dataSource={files}
        rowKey={(record) => record.getUUID()}
        pagination={
          pagination.total > pagination.pageSize
            ? {
              ...pagination,
              position: ['bottomCenter']
           }
            : false
        }
        onChange={(pagination) => onPageChange(pagination.current)}
        rowClassName={record =>
          activeFile &&
          record.getUUID() === activeFile.getUUID()
            ? 'active-file-row'
            : ''
        }
      />
      <FilePreviewDrawer
        visible={drawerVisible}
        onClose={handleDrawerClose}
        file={selectedFile}
        onOpenFullFile={handleOpenFullFile}
      />
    </div>
  );
} 